<div class="widget serviceOrders">
  <p-tabs [value]="tabValue" class="customTabView">
    <p-tablist>
      <p-tab value="0">{{ "predictive_services.title" | translate }}</p-tab>
      <p-tab value="1">{{ "service_contracts.title" | translate }}</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel
        value="0"
        *appHasPermission="{
          permissions: [
            permissions.allPermissions.ASSET_COMPONENT_READ,
            permissions.allPermissions.ASSET_MASTER_DATA_READ,
          ],
        }"
      >
        @defer {
          <app-predictive-service></app-predictive-service>
        } @placeholder {
          <div></div>
        }
      </p-tabpanel>
      <p-tabpanel
        value="1"
        *appHasPermission="{
          permissions: [
            permissions.allPermissions.INT_SERVICE_CONTRACT_READ,
            permissions.allPermissions.EXT_SERVICE_CONTRACT_READ,
          ],
        }"
      >
        @defer (on viewport) {
          <app-service-contracts></app-service-contracts>
        } @placeholder {
          <div></div>
        }
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
